"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var BHTP_RADIO_BUTTON_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return BhtpRadioButtonComponent; }),
    multi: true
};
var BhtpRadioButtonComponent = (function () {
    function BhtpRadioButtonComponent() {
        this.propagateChange = function (_) { };
        this.onTouched = function () { };
        /**
         * End of ControlValueAccessor implementation
         */
    }
    /**
     * Start of ControlValueAccessor methods, generally,we shouldn't need to provide anything other that base implementations for these
     * as we are passing the control being bound to this element down into the native radio button element
     */
    BhtpRadioButtonComponent.prototype.writeValue = function (obj) { };
    BhtpRadioButtonComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    BhtpRadioButtonComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    BhtpRadioButtonComponent.prototype.setDisabledState = function (isDisabled) { };
    return BhtpRadioButtonComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], BhtpRadioButtonComponent.prototype, "value", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.AbstractControl)
], BhtpRadioButtonComponent.prototype, "formControl", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], BhtpRadioButtonComponent.prototype, "name", void 0);
BhtpRadioButtonComponent = __decorate([
    core_1.Component({
        selector: 'bhtp-radio-button',
        template: "<label *ngIf=\"formControl\">     <span *ngIf=\"formControl.value === value\" class=\"fa fa-lg fa-check-circle selected\" [ngClass]=\"{'disabled': formControl.disabled}\"></span>     <span *ngIf=\"formControl.value !== value\" class=\"fa fa-lg fa-circle-o\" [ngClass]=\"{'disabled': formControl.disabled}\"></span>     <input [formControl]=\"formControl\" [value]=\"value\" type=\"radio\" class=\"hidden-control\" /> </label>",
        styles: [".hidden-control {     display: none; }  .selected {     color: #364F78; }  .disabled, .selected.disabled {     color: #A6A6A6; }"],
        providers: [BHTP_RADIO_BUTTON_VALUE_ACCESSOR]
    })
], BhtpRadioButtonComponent);
exports.BhtpRadioButtonComponent = BhtpRadioButtonComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/form-controls/bhtp-radio-button.component.js